import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import dbSelector from './dbSelector';
import {
    selectGeneralAdmissionsInHall,
    selectSectorsInHall,
    selectRoundTablesInHall,
    selectRectangleTablesInHall,
} from '%paysera_seat_selection/js/seatSelection/redux';
import extractModelsWithoutTicketTypeAndReservation from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/extractModelsWithoutTicketTypeAndReservation';
import { extractSeatingsFromSelection } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/extractSeatsFromSelection';

const selectModelsWithoutTicketTypeAndReservation = createSelector(
    orm,
    dbSelector,
    state => selectGeneralAdmissionsInHall(state),
    state => selectSectorsInHall(state),
    state => selectRoundTablesInHall(state),
    state => selectRectangleTablesInHall(state),
    (state, generalAdmissions, sectors, roundTables, rectangleTables) => {
        const seatings = extractSeatingsFromSelection([
            ...generalAdmissions,
            ...sectors,
            ...roundTables,
            ...rectangleTables,
        ]);
        return extractModelsWithoutTicketTypeAndReservation(seatings);
    },
);

export default selectModelsWithoutTicketTypeAndReservation;
